<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="2">
          <v-sheet rounded="lg">
            <v-list-item
              v-for="(item, index) in listItems"
              :key="index"
              :class="{ active: currentTab === item.name }"
              @click="selectTab(item.name)">
              {{ item.label }}
            </v-list-item>
          </v-sheet>
        </v-col>

        <v-col>
          <v-sheet min-height="70vh" rounded="lg">
            <component
              :is="currentComponent"
              v-if="currentComponent && currentProps"
              v-bind="currentProps"
              @snack="throwSnack" />
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
import JudgingYearAssignmentSubView from './subviews/JudgingYearAssignmentSubView.vue';
import JudgingYearRoundsSubView from './subviews/JudgingYearRoundsSubView.vue';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();

const { throwSnack } = useSnack(emit);
const route = useRoute();
const router = useRouter();

const yearId = ref(
  Array.isArray(route.params.yearId) ? route.params.yearId[0] : (route.params.yearId ?? ''),
);

const componentProps = computed(() => {
  return { yearId: yearId.value };
});

const listItems = computed(() => [
  {
    name: 'round',
    label: 'Rounds',
    component: JudgingYearRoundsSubView,
    props: componentProps.value,
  },
  {
    name: 'assign',
    label: 'Assignment',
    component: JudgingYearAssignmentSubView,
    props: componentProps.value,
  },
]);

const currentTab = ref(route.params.tabName || 'round');

const currentTabItem = computed(() => listItems.value.find((i) => i.name === currentTab.value));

const currentComponent = computed(() => currentTabItem.value?.component || null);
const currentProps = computed(() => currentTabItem.value?.props || null);

function selectTab(tabName: string) {
  currentTab.value = tabName;
}

watch(
  currentTab,
  (newTab) => {
    router.push({
      name: 'AdminJudgeYearEdit',
      params: { yearId: yearId.value, tabName: newTab },
    });
  },
  { immediate: true },
);
</script>
